import Vue from 'vue';
import {
  Button, Card, Input, InputNumber, Checkbox, Link, Form, FormItem, Divider,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Avatar,
  Icon,
  Tooltip,
  Notification,
  PageHeader,
  RadioButton,
  RadioGroup,
  Table,
  TableColumn,
  Loading,
  TabPane,
  Tabs,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/vi';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(Button);
Vue.use(Card);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Checkbox);
Vue.use(Link);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Divider);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Icon);
Vue.use(Avatar);
Vue.use(Tooltip);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(PageHeader);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Loading.directive);
Vue.use(Tabs);
Vue.use(TabPane);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
